import { BankAccountNumber } from './BankAccountNumber';
import { PreviousTransactions } from './PreviousTransactions';
import { Sign } from './Sign';
import { Summary } from './Summary';
import { UploadDocumentation } from './UploadDocumentation';

export const getSteps = () => [
  { id: 'summary', element: <Summary /> },
  { id: 'account', element: <BankAccountNumber /> },
  { id: 'transactions', element: <PreviousTransactions /> },
  { id: 'upload', element: <UploadDocumentation /> },
  { id: 'sign', element: <Sign /> },
];
